document.addEventListener("DOMContentLoaded", function() {
  const balloons = document.querySelectorAll('.yg-merit__balloon');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const balloon = entry.target;
        balloon.classList.add('visible');
        
        // 遅延を設定
        const delay = balloon.dataset.delay;
        balloon.style.transitionDelay = delay;
        
        // 一度表示されたら監視を解除
        observer.unobserve(balloon);
      }
    });
  }, {
    threshold: 0.1 // 10%が表示されたときに発火
  });

  balloons.forEach(balloon => {
    observer.observe(balloon);
  });
});